import React from 'react';


export default function RIQDropdownTitle({label, className, selectionSummary}) {

    className ??= 'tlw-text-sm tlw-leading-14';

    return (
        <div className='tlw-mr-9 tlw-text-left'>
            {label && <div className='tlw-text-10 tlw-leading-12 tlw-text-gray-500' >{label}</div>}
            <div
                className={`tlw-overflow-hidden tlw-text-ellipsis ${className}`}
                style={{
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 1
                }}
            >
                {selectionSummary}
            </div>
        </div>
    );
}
